import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "..";
import service from "../../services/api.service";
import { plainToClass } from "class-transformer";
import { getTenantId } from "@/store/helper";
import { Guid } from "guid-typescript";
import { IGridOption } from "../models/shared/gridOption";
import { StateModel } from "../models/state/stateDTO";
import { StateSaveModel } from "../models/state/stateSaveDTO";
let StatesModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g;
    let StatesModule = class StatesModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.apiNode = "state";
            this.states = [];
            this.totalCount = 0;
        }
        async GetStates(searchData) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.post(url, searchData);
            if (data) {
                this.SetStates(plainToClass(StateModel, data.states));
                this.SetTotalCount(data.totalCount);
                return data;
            }
        }
        async AddState(state) {
            var url = `${getTenantId()}/${this.apiNode}/add`;
            let { data } = await service.post(url, state);
            if (data) {
                return data;
            }
        }
        async EditState(state) {
            var url = `${getTenantId()}/${this.apiNode}/update`;
            let { data } = await service.put(url, state);
            if (data) {
                return data;
            }
        }
        async DeleteStateById(stateId) {
            var url = `${getTenantId()}/${this.apiNode}/delete/` + stateId;
            let { data } = await service.delete(url);
            if (data) {
                return data;
            }
        }
        SetStates(states) {
            this.states = states;
        }
        SetTotalCount(count) {
            this.totalCount = count;
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof IGridOption !== "undefined" && IGridOption) === "function" ? _a : Object]),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], StatesModule.prototype, "GetStates", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_c = typeof StateSaveModel !== "undefined" && StateSaveModel) === "function" ? _c : Object]),
        __metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
    ], StatesModule.prototype, "AddState", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof StateSaveModel !== "undefined" && StateSaveModel) === "function" ? _e : Object]),
        __metadata("design:returntype", typeof (_f = typeof Promise !== "undefined" && Promise) === "function" ? _f : Object)
    ], StatesModule.prototype, "EditState", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_g = typeof Guid !== "undefined" && Guid) === "function" ? _g : Object]),
        __metadata("design:returntype", Promise)
    ], StatesModule.prototype, "DeleteStateById", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], StatesModule.prototype, "SetStates", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], StatesModule.prototype, "SetTotalCount", null);
    StatesModule = __decorate([
        Module({ dynamic: true, store: store, name: "state", namespaced: true })
    ], StatesModule);
    return StatesModule;
})();
export const StateModule = getModule(StatesModule);
